import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../../api/client'

/** Course catalog (with my progress/enrolment) — GET /learning/courses. */
export function useCourses() {
  return useQuery({ queryKey: ['courses'], queryFn: () => api.courses() })
}

/** My learning stats — GET /learning/me/summary. */
export function useLearningSummary() {
  return useQuery({ queryKey: ['learning-summary'], queryFn: api.learningSummary })
}

const invalidate = (qc: ReturnType<typeof useQueryClient>, id: string) => {
  qc.invalidateQueries({ queryKey: ['courses'] })
  qc.invalidateQueries({ queryKey: ['course', id] })
  qc.invalidateQueries({ queryKey: ['learning-summary'] })
}

/** Enroll into a course — POST /learning/courses/:id/enroll. */
export function useEnrollCourse() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.enrollCourse(id),
    onSuccess: (_d, id) => invalidate(qc, id),
  })
}

/** Set my progress (0..100) — PATCH /learning/courses/:id/progress. */
export function useSetCourseProgress() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, progress }: { id: string; progress: number }) => api.setCourseProgress(id, progress),
    onSuccess: (_d, { id }) => invalidate(qc, id),
  })
}
